"use client";

import { Suspense,  useMemo } from "react";
import HomePageClient from "@/components/HomePageClient";

/**
 * Extracts the show slug from the URL path synchronously
 * This avoids the "default" slug being used initially
 */
function getShowSlugFromPath(): string {
  if (typeof window === "undefined") {
    return "default";
  }

  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  return pathSegments[0] || "default";
}

/**
 * Wrapper component that extracts show slug before rendering HomePageClient
 * This prevents the initial "default" API request
 */
export default function ShowPageWrapper() {
  // Extract slug synchronously during render (not in useEffect)
  const showSlug = useMemo(() => getShowSlugFromPath(), []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <HomePageClient showSlug={showSlug} />
    </Suspense>
  );
}
